import React from 'react';
import {sendEventToGA} from "./../../utils.js";
import {CdaWebModalDropdownButton} from './cdawebmodaldropdownbutton.js';


/**
 * Modal buttons that deal with interacting with plot result that is returned from CDAWeb.
 * @param props.loading Boolean that indicates if in loading state
 * @param props.handleNewWindow Function that deals with opening selected data in new window.
 * @param props.handleDownload Function that deals with downloading selected data.
 * @param props.handlePan Function that deals with panning the plot left or right. Note that this triggers new request
 * @param props.handleZoom Function that deals with zooming in into or out of the plot. Note that this triggers new request
 * @param props.availableImageTypes A String arrays of available image types.
 * @return JSX
 */
export function CdaWebModalGraphButtonsRow(props) {

    const { title, handleNewWindow, loading, handleDownload, handlePan, handleZoom, availableImageTypes} = props;

    let buttons = [
            { id: 1, text: '<<Pan Left', action: ()=>{handlePan(true)}},
            { id: 2, text: 'Pan Right>>', action: ()=>{handlePan(false)}},
            { id: 3, text: '>>Zoom In<<', action: ()=>{handleZoom(true)}},
            { id: 4, text: '<<Zoom Out>>', action: ()=>{handleZoom(false)}},
            { id: 5, text: 'Move To New Window', action: handleNewWindow},
            { id: 6, text: 'Download Plot', action: handleDownload},
        ]

    const validBrowserImageTypes = availableImageTypes.filter(el => ['png','pdf'].includes(el));

    const handleClick = (button) => {
        if (button.action) {
            if(button.text === 'Download Plot') {
                sendEventToGA(`dataset_access__cdaweb_modal_${button?.text?.replace(" ", "_")}__button`, title);
            }
            button.action();
        }
    };

    return (
       <div className="cdaWebModalButtonRowCenter">
         <div className="cdaWebModalButtonRow cdaWebMediumMargin">
           {buttons.map((button, index) => (button.id === 6 || button.id === 5)
           ?
           <CdaWebModalDropdownButton
             key={index + 700}
             options={button.id === 6 ? availableImageTypes : validBrowserImageTypes}
             button={button}
             prefix={button.id === 6 ? "Download as" : "Move "} />
           :
           (
              <button
                 key={index}
                 className={`cdaWebModalButton ${ button.id < 5 & loading ? 'graphButton' : ''}`}
                 disabled={false}
                 onClick={()=>handleClick(button)}>{button.text}
              </button>
           ))}
         </div>
       </div>
    );
};
